import { createLazy } from '@zajno/common/lazy/light';
import { createControllerImportLoader, createControllerLoader } from './core/loader';
import { FlagModel } from '@zajno/common-mobx/viewModels';
import UsersController from './users';
import { ProductsController } from './products';
import { CampaignsController } from './campaigns';

export class AppController {
    private static readonly _instance = createLazy(() => new AppController());
    public static get Instance() { return AppController._instance.value; }

    private readonly _auth = createControllerImportLoader(() => import('./auth'), true);
    private readonly _users = createControllerLoader(() => new UsersController(() => this._auth.value));
    private readonly _products = createControllerLoader(() => new ProductsController());
    private readonly _campaigns = createControllerLoader(() => new CampaignsController());

    private readonly _isInitializing = new FlagModel(true);

    private constructor() {
        // no-op
    }

    public get isInitializing() { return this._isInitializing.value; }

    public get Auth() { return this._auth.value; }
    public get Users() { return this._users.value; }
    public get Products() { return this._products.value; }
    public get Campaigns() { return this._campaigns.value; }

    public async initialize() {
        this._isInitializing.setTrue();
        await Promise.all([
            this._auth.promise,
            this._users.promise,
            this._products.promise,
            this._campaigns.promise,
        ]);
        this._isInitializing.setFalse();
    }

    public dispose() {
        [
            this._campaigns,
            this._products,
            this._users,
            this._auth,
        ].forEach(x => {
            if (x.hasValue) {
                x.value.dispose();
            }
        });
    }
}
